module.exports = __webpack_public_path__ + "img/king-of-pops-2.e954882e.png";